<template>
  <v-chip
    v-bind="$attrs"
    :color="chipColor"
    @click="onClick"
  >
    <v-icon
      :color="checkBoxColor"
      left
    >
      {{ checkBoxIcon }}
    </v-icon>
    <slot />
  </v-chip>
</template>

<script>
export default {
  name: 'CheckChip',
  props: {
    errorMessages: {
      type: Array,
      default () {
        return []
      }
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    },
    error: {
      type: Boolean,
      default () {
        return false
      }
    },
    readOnly: {
      type: Boolean,
      default () {
        return false
      }
    },
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    color: {
      type: String,
      default () {
        return undefined
      }
    },
    onIcon: {
      type: String,
      default () {
        return 'mdi-checkbox-marked'
      }
    },
    offIcon: {
      type: String,
      default () {
        return 'mdi-checkbox-blank-outline'
      }
    }
  },
  data: function () {
    return {
      daySelectorErrors: [],
      lazyValue: false,
      isDirty: false
    }
  },
  computed: {
    hasError () {
      return this.error || !!(this.errorMessages && this.errorMessages[0])
    },
    checkBoxIcon () {
      return this.lazyValue ? this.onIcon : this.offIcon
    },
    checkBoxColor () {
      return this.hasError ? 'error' : this.lazyValue ? 'primary' : 'grey'
    },
    chipColor () {
      return this.hasError ? 'error' : this.color
    }
  },
  watch: {
    value (v) {
      this.lazyValue = v
    }
  },
  created () {
    this.lazyValue = this.value
  },
  methods: {
    onClick (e) {
      if (this.readOnly || this.disabled) return
      this.lazyValue = !this.lazyValue
      this.isDirty = true
      this.$emit('click', e)
      this.$emit('input', this.lazyValue)
      this.$emit('change', this.lazyValue)
    }
  }
}
</script>
